import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import xamatron from "xamatron";
var AiDealerDetails = /** @class */ (function (_super) {
    tslib_1.__extends(AiDealerDetails, _super);
    function AiDealerDetails() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AiDealerDetails.prototype.sanitizePhoneNumber = function (phone) {
        return phone
            .replace(/\s/g, "")
            .split("")
            .map(this.replaceLetter)
            .join("");
    };
    AiDealerDetails.prototype.replaceLetter = function (letter) {
        var letterToNum = { "abc": "2", "def": "3", "ghi": "4", "jkl": "5", "mno": "6", "pqrs": "7", "tuv": "8", "wxyz": "9" };
        var c = letter.toLowerCase();
        for (var k in letterToNum) {
            if (k.indexOf(c) != -1)
                return letterToNum[k];
        }
        return letter;
    };
    AiDealerDetails.prototype.open = function (url) {
        xamatron.openURL(url);
    };
    tslib_1.__decorate([
        Prop(),
        tslib_1.__metadata("design:type", Object)
    ], AiDealerDetails.prototype, "dealer", void 0);
    AiDealerDetails = tslib_1.__decorate([
        Component
    ], AiDealerDetails);
    return AiDealerDetails;
}(Vue));
export default AiDealerDetails;
